import { RoutePath } from "@/types";

export const accountRoutes: RoutePath[] = [
    {
        path: "/",
        name: "Home",
    },
    {
        path: "/wachtwoord-aanpassen",
        name: "UpdatePassword",
    },
];
